var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeriveProtocol(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80C62.0914 80 80 62.0914 80 40Z",
    fill: "#0A0A0A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2459 42.5889L46.438 14.1433C46.3459 14.0052 46.1327 14.0633 46.123 14.2281C46.0794 14.9479 45.4711 18.7913 41.1381 18.7913C37.6217 18.7913 36.0005 18.1589 32.3777 18.1589C31.1247 18.1589 29.6344 18.8688 28.8516 20.0563L27.3733 22.2931L41.5234 43.6892H47.0584C48.6917 43.6892 50.2161 44.5082 51.1152 45.8701L54.4958 50.9835H66.0069V45.1043C66.0069 44.2126 65.7427 43.3378 65.2483 42.5913L65.2459 42.5889ZM49.8114 30.4042C47.5383 29.4832 45.7667 25.4532 45.7667 25.4532C50.3566 25.4532 53.4538 30.9228 53.4538 30.9228C53.4538 30.9228 52.0845 31.3251 49.8114 30.4042Z",
    fill: "url(#paint0_linear_697_83)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2266 61.9178H27.4413C25.9485 61.9203 24.5551 61.1714 23.7312 59.9258L14.881 46.5414C13.805 44.9153 13.805 42.8022 14.881 41.1761L24.7247 26.3062L24.7296 26.3014L48.2243 61.9153L48.2266 61.9178Z",
    fill: "url(#paint1_linear_697_83)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_697_83",
    x1: 46.69,
    y1: 50.9835,
    x2: 46.69,
    y2: 14.0659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB124"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F63E58"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_697_83",
    x1: 31.1504,
    y1: 61.9178,
    x2: 31.1504,
    y2: 26.3014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB124"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F63E58"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeriveProtocol);
export default __webpack_public_path__ + "static/media/derive_protocol.fb1adc11e52e1509e4cb2915692023c8.svg";
export { ForwardRef as ReactComponent };